interface ThemeType {
  [key: string]: any;
}

const neutralColors: ThemeType = {
  25: "#FAFAF9",
  50: "#F1F1EF",
  100: "#E5E2DC",
  200: "#D2CEC6",
  300: "#BFBCB5",
  400: "#969188",
  500: "#7B756B",
  600: "#5E584F",
  700: "#44413B",
  800: "#302D27",
  900: "#221E16",
};

export default neutralColors;
